// extracted by mini-css-extract-plugin
export default {"cta":"vF-z","disabled":"wF-z"};